import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BtnCellRenderer from "../../common/BtnCellRenderer";

import Components from "../roomMaster/index";

import { roomMasterActions } from "../../../core/actions";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { InputAdornment, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function RoomMasterList(props) {
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState("");
  const [roomSearchList, setroomSearchList] = useState({});
  const [roomMasterSearchFilterList, setroomMasterSearchFilterList] = useState(
    {}
  );
  const [addRoomMaster, setRoomMaster] = useState(false);

  const handleServices = (service) => {
    console.log("service selected :", service);
  };

  const clearSearch = (event) => {
    setSearchText("");
  };
  useEffect(() => {
    dispatch(
      roomMasterActions.roomList((resCb) => {
        console.log("roomMasterActions.roomList", resCb);
        setroomSearchList(resCb.roomList);
        setroomMasterSearchFilterList(resCb.roomList);
      })
    );
  }, []);
  const closeServiceModal = (event) => {
    props.onModalClose(event);
  };

  const handleClick = (pDetail, isAddNew) => {
    setRoomMaster(!addRoomMaster);
    console.log("props.history", props);
    props.history.push("/roommaster");
  };

  const handleInputChange = (event) => {
    let emptymsg = {};
    let value = event.target.value;
    validateAndChange(value);
    console.log("value...", value);
  };

  const validateAndChange = (value) => {
    let nullarray = [];

    if (value.length < 3) {
      setSearchText(value);
      setroomMasterSearchFilterList(roomSearchList);
    }
    if (!value) {
      console.log("roomSearchList null array !value : ", value, roomSearchList);

      setroomMasterSearchFilterList(roomSearchList);
    }

    if (value.length >= 3) {
      setSearchText(value);
      let search = { patient: value };
      console.log("search input : ", value);
      searchRoomResult(value);
    }
  };

  const searchRoomResult = (data) => {
    console.log("data searched ", data);

    let filteredData = roomSearchList.filter((item) => {
      return item.roomName && item.roomName.includes(data);
    });

    setroomMasterSearchFilterList(filteredData);

    console.log("filteredData", roomMasterSearchFilterList);

    return roomMasterSearchFilterList;
  };
  const closeModal = (data) => {
    console.log("data ::", data);
    setRoomMaster(!addRoomMaster);
  };
  const callBackGrid = (data) => {
    console.log("datadata", data);
    dispatch(
      roomMasterActions.roomList((resCb) => {
        if (resCb) {
          console.log("resCb::", resCb);
          console.log("resCb::", resCb.roomList);
          setroomSearchList(resCb.roomList);
          setroomMasterSearchFilterList(resCb.roomList);
          console.log("response from api : ", resCb);
        }
      })
    );
  };
  return (
    <>
      <div class="mainsection">
        {/* <div className='border-bottom'>
          <span className="topright d-flex justify-content-end pl-4 pt-3 mr-4"  onClick={(event)=>closeServiceModal(event)}>X</span>       
       </div> */}
        <div className="listTitles">
          <Grid item xs={12} className="page-header mb-3 doctorList">
            <h5
              // subtitle="Dashboard"
              className="text-sm-left mb-0"
            >
              Rooms
            </h5>

            <Button
              variant="contained"
              className="floatingbtn"
              onClick={(event) => handleClick("", true)}
              style={{ textTransform: "none" }}
            >
              Add New
            </Button>
          </Grid>
        </div>
        <form className="main-navbar__search w-100 d-md-flex d-lg-flex">
          <div className="input-group input-group-seamless">
            <div className="input-group-prepend mb-2">
              <span className="input-group-text">
                <i style={{ color: `#111b21` }} className="material-icons">
                  search
                </i>
              </span>
            </div>
            {/* <FormInput
              className="navbar-search mb-2 menu-search bg-white"
              placeholder="Search RoomName..."
              value={searchText}
              type="search"
              onChange={handleInputChange}
            /> */}
            <TextField
              className="navbar-search mb-2 menu-search bg-white custom-text"
              placeholder="Search RoomName..."
              autoFocus
              value={searchText}
              type="search"
              onChange={handleInputChange}
              InputProps={{
                style: { paddingLeft: "15px", height: "35px" },
                endAdornment: (
                  <InputAdornment position="end">
                    {searchText && ( // Render the close icon only if searchText exists
                      <IconButton
                        edge="end"
                        onClick={clearSearch}
                        tabIndex={-1}
                        size="small"
                        style={{ padding: "6px" }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </form>
        {roomMasterSearchFilterList &&
          roomMasterSearchFilterList.length > 0 && (
            <Components.RoomMasterGrid
              roommaster={roomMasterSearchFilterList}
              onGridAction={(event) => callBackGrid(event)}
            />
          )}

        {/* {addRoomMaster && ( */}
        {/* <div > */}

        {/* <Components.addRoomMaster onModalClose={(event) => closeModal(event)} /> */}

        {/* </div>)} */}
      </div>
    </>
  );
}
export default RoomMasterList;
